export const PageText = {
  _1: 'Air pollution & the curse of the 3C\'s',
  _2: 'When you drink and drive and you have a car accident. The cause is quite clear. But, a lifelong exposure to high NO<sub>2</sub> levels can have even worse consequences. What can we do about it? How do we know what the air quality is right now exactly where we are?'
};

export const Categories = {
  _1: {
    title: 'The curse of the 3 C’s',
    subcategories: [
      {
        key: 0,
        subtitle: 'Colourless',
        text: 'Just because you cannot see air pollution, does not mean it is not there!'
      },
      {
        key: 1,
        subtitle: 'Complex',
        text: 'What do these concentrations of different pollutants mean for my health?'
      },
      {
        key: 2,
        subtitle: 'Coarse',
        text: 'Sensor data gives an idea of the AQ only for that location. But what about the AQ for every location?'
      }
    ]
  },
  _2: {
    title: 'The aircheckr solution',
    subcategories: [
      {
        key: 0,
        subtitle: 'One colour',
        text: 'We give air quality a colour, so it\'s clear if the air is good or bad'
      },
      {
        key: 1,
        subtitle: 'Simple',
        text: 'Aircheckr takes away the complexity and translates air quality data into just one, easy to interpret value'
      },
      {
        key: 2,
        subtitle: 'Detailed',
        text: 'We provide detailed air quality info of quality.'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/air-pollution-and-the-curse_page.js